import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
 selector: 'formly-field-input',
 template: `
 <div [ngSwitch] = "to?.type">
   <input *ngSwitchCase = "'decimal'" currencyMask [tooltip]="to?.tooltip" class="form-control" [formControl]="formControl" [formlyAttributes]="field">
   <input *ngSwitchDefault  [tooltip]="to?.tooltip" class="form-control" [type]="to?.type" [formControl]="formControl" [formlyAttributes]="field">
  </div>`,
})
export class FormlyFieldInput extends FieldType {}